import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=d97461f6&"
import script from "./BottomMenu.vue?vue&type=script&lang=ts&"
export * from "./BottomMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports